import { AddCircleOutlineOutlined } from "@mui/icons-material";
import { Button } from "@mui/material";

import { SETTLEMENT_STYLES } from "../../style/styles";

export default function MedicalBreakdownAddButton({ onClick }) {
  return (
    <Button
      variant="contained"
      color="primary"
      onClick={onClick}
      className="max-w-50 min-w-40 normal-case"
      endIcon={<AddCircleOutlineOutlined />}
      sx={SETTLEMENT_STYLES.addButton}
    >
      Add
    </Button>
  );
}
